<div class="single-toolbar d-flex justify-content-between" *ngIf="!loading">
  <div class="tb-pdf-controls" style="width:100%">
    <ng-container>
      <button title="Previous Job" (click)="proceedToNextJob('previous')" class="btn btn-default btn-rotate-left">
        <nb-icon icon="arrow-circle-left-outline"></nb-icon>
      </button>
      <div class="h-seperator"></div>
    </ng-container>
    <!-- <ng-container>
      <button nbButton ghost status="primary" title="Reprocess" (click)="onReprocessClick()">
        <nb-icon icon="flip-2-outline"></nb-icon>
      </button>
      <div class="h-seperator"></div>
    </ng-container> -->
    <!-- <ng-container>
      <button title="Draw Table" nbButton ghost type="button" status="primary" size="small" nbPopoverPlacement="bottom"
        [nbPopover]="drawTableactionBtnList" nbPopoverTrigger="noop" (click)="triggerNbPopover()">
        <nb-icon pack="single-toolbar" icon="draw-table"></nb-icon>
      </button>
      <ng-template #drawTableactionBtnList>
        <div class="btn-group" role="group">
            &nbsp;
            <button title="x-axes skew(+)" outline size="small" status="info" (click)="deskewImage('x+')">
              x-skew(+)
            </button>
            <span class="separator"></span>
            <input style="width: 60px; text-align:center;" [value]="skewFactorX" type="number" (change)="inputSkewFactor($event, 'x')"/>
            <span class="separator"></span>
            <button title="x-axes skew(-)" outline size="small" status="primary" (click)="deskewImage('x-')">
              x-skew(-)
            </button>
            <span class="separator"></span>
            <button title="reset skew" [disabled]="!skewFactorX && !skewFactorY" outline size="small" status="primary" (click)="deskewImage('reset')">
              <nb-icon icon="refresh"></nb-icon>
            </button>
            <span class="separator"></span>
            <button title="save skew Img" [disabled]="!skewFactorX && !skewFactorY" outline size="small" status="danger" (click)="saveUpdatedImage('save')">
              <nb-icon icon="save"></nb-icon>
            </button>
            <span class="separator"></span>
            <button title="y-axes skew(+)" outline size="small" status="info" (click)="deskewImage('y+')">
              y-skew(+)
            </button>
            <span class="separator"></span>
            <input style="width: 60px; text-align:center;" [value]="skewFactorY" type="number" (change)="inputSkewFactor($event, 'y')"/>
            <span class="separator"></span>
            <button title="y-axes skew(-)" outline size="small" status="primary" (click)="deskewImage('y-')">
              y-skew(-)
            </button>
            <span class="separator"></span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <button title="Views" [disabled]="lineDraw" outline size="small" status="info" (click)="layers()">
              <nb-icon icon="layers-outline"></nb-icon>
            </button>
            <span class="separator"></span>
            <button title="Horizontal Line" outline size="small" status="primary" (click)="horizontalLine()">
              <nb-icon icon="more-horizontal"></nb-icon>
            </button>
            <span class="separator"></span>
            <button title="Vertical Line" outline size="small" status="info" (click)="verticalLine()">
              <nb-icon icon="more-vertical"></nb-icon>
            </button>
            <span class="separator"></span>
            <button title="Proceed" [disabled]="!lineDraw" outline size="small" status="danger" (click)="processTable()">
              <nb-icon icon="save"></nb-icon>
            </button>
            &nbsp;
        </div>
      </ng-template>
      <div class="h-seperator"></div>
    </ng-container> -->
    <!-- <ng-container>
      <button title="Undo table Changes" (click)="undoTableChanges()" [disabled]="!hasChanges"  class="btn btn-default btn-rotate-left">
        <nb-icon icon="undo"></nb-icon>
      </button>
    </ng-container> -->

    <!-- <ng-container *ngIf="!fetchAllTables">
      <nb-checkbox status="success" [checked]="displayStandardFields" (change)="toggle($event)">
        Header
      </nb-checkbox>
      <div class="h-seperator"></div>
    </ng-container> -->
    <!-- <ng-container>
      <button type="button" nbButton ghost [disabled]="pageIndex==0" (click)="changePage(pageIndex - 1, null)"
        title="Previous Page">
        <nb-icon pack="single-toolbar" icon="page-up"></nb-icon>
      </button>
      <button type="button" nbButton ghost [disabled]="pageIndex==noOfPages-1" (click)="changePage(pageIndex + 1, null)"
        title="Next Page">
        <nb-icon pack="single-toolbar" icon="page-down"></nb-icon>
      </button>
      <input style="width: 35px; text-align:center" [value]="pageIndex + 1" type="number"
        (change)="inputPageNumber($event)" />&nbsp;of {{noOfPages}}
      <div class="h-seperator"></div>
    </ng-container> -->
    <!-- <ng-container *ngIf="startPageNos.length > 0">
      <nb-select status="success" shape="round" size="small" [selected]="statementNo"
        (selectedChange)="switchSatement($event)">
        <nb-option *ngFor="let _ of startPageNos; let i = index" [value]="i"> Statement {{ i + 1
          }}/{{startPageNos.length}}</nb-option>
      </nb-select>
      <div class="h-seperator"></div>
    </ng-container> -->
    <!-- <ng-container *ngIf="errorPagesConsolidated.length !==0">
      <span style="color:red">
        <button [disabled]="errorPagesConsolidated.length==0 || (errorPageClick - 1 <=0)" (click)="showErrorPage('B')"
          class="btn btn-default btn-rotate-left">
          <nb-icon icon="arrow-ios-back-outline"></nb-icon>
        </button>
        Review
        {{(pageIndex === 0 && errorPagesConsolidated.includes(pageIndex + 1)) ?
        resetErrPgClick(1) : findErrorPageClick()}}/{{errorPagesConsolidated.length}}
        <button [disabled]="errorPagesConsolidated.length== 0 ||
         (errorPageClick > 0 && !errorPagesConsolidated[errorPageClick - 1]) ||
         (errorPageClick > errorPagesConsolidated.length - 1)" (click)="showErrorPage('F')"
          class="btn btn-default btn-rotate-left">
          <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
        </button>
      </span>
      <div class="h-seperator"></div>
    </ng-container> -->
    <!-- <ng-container>
      <button nbButton ghost status="primary" title="Add comment" (click)="onPopverAddCommentClick()">
        <nb-icon pack="single-toolbar" icon="comment"></nb-icon>
      </button>
      <div class="h-seperator"></div>
    </ng-container> -->
    <ng-container>
      <button nbButton outline status={{statusColor}} size="small" [nbPopover]="actionBtnListOne"
        nbPopoverPlacement="bottom">{{status}}</button>
      <ng-template #actionBtnListOne>
        <div style="padding: 5px;width: 200px;" class="action-button-wrapper">
          <ng-container *ngIf="status === 'Verified'">
            <button style="margin: 2px;" nbButton outline status="warning" size="medium" fullWidth
              (click)="jobVerifiedStatus('W')">
              Processed
            </button>
            <button style="margin: 2px;" nbButton outline status="danger" size="medium" fullWidth
              (click)="jobVerifiedStatus('F')">
              Failed
            </button>
          </ng-container>
          <ng-container *ngIf="status === 'Failed'">
            <button style="margin: 2px;" nbButton outline status="warning" size="medium" fullWidth
              (click)="jobVerifiedStatus('W')">
              Processed
            </button>
            <button style="margin: 2px;" nbButton outline status="success" size="medium" fullWidth
              (click)="jobVerifiedStatus('V')">
              Verified
            </button>
          </ng-container>
          <ng-container *ngIf="status === 'Processed'">
            <button style="margin: 2px;" nbButton outline status="success" size="medium" fullWidth
              (click)="jobVerifiedStatus('V')">
              Verified
            </button>
            <button style="margin: 2px;" nbButton outline status="danger" size="medium" fullWidth
              (click)="jobVerifiedStatus('F')">
              Failed
            </button>
          </ng-container>
        </div>
      </ng-template>
      <div class="h-seperator"></div>
    </ng-container>
    <ng-container>
      <button title="Export" nbButton  (click)="export('1', popover)" [status]="info" size="small" 
        >
        <nb-icon icon="cloud-download-outline"></nb-icon>
      </button>
      <ng-template #actionBtnList>
        <div style="padding: 5px;width: 200px;" class="action-button-wrapper">
          <ng-container *ngIf="!fetchAllTables">
            <button style="margin: 2px;" status="info" nbButton outline size="tiny" fullWidth
              (click)="export('1', popover)">
              CSV (Debit + Credit)
            </button>
            <button style="margin: 2px;" status="info" nbButton outline size="tiny" fullWidth
              (click)="export('2', popover)">
              CSV (Debit | Credit)
            </button>
          </ng-container>
          <ng-container *ngIf="fetchAllTables">
            <!-- <button style="margin: 2px;" status="info" nbButton outline size="tiny" fullWidth
              (click)="export('A-R', popover)">
              Resized
            </button> -->
            <button style="margin: 2px;" status="info" nbButton outline size="tiny" fullWidth
              (click)="export('A-A', popover)">
              Actual
            </button>
          </ng-container>
        </div>
      </ng-template>
      <div class="h-seperator"></div>
    </ng-container>
    <ng-container>
      <button nbButton ghost status="primary" title="File Info" (click)="onPopverInfoClick()">
        <nb-icon icon="info-outline"></nb-icon>
      </button>
      <div class="h-seperator"></div>
    </ng-container>
    <ng-container>
      <button title="Next Job" (click)="proceedToNextJob('next')" class="btn btn-default btn-rotate-left">
        <nb-icon icon="arrow-circle-right-outline"></nb-icon>
      </button>
    </ng-container>
  </div>
</div>